import {
	EuiCard,
	EuiCheckbox,
	EuiFieldText,
	EuiFormRow,
} from '@equipmentshare/ds2'

import CurrencyField from 'components/CurrencyField/currencyField'
import ProviderPicker from '../../../../../components/ProviderPicker'
import ProductClassPicker from '../ProductClassPicker'

import { ProductClass } from '../../../../../graphql'

import styles from '../form-styles.module.css'

export type PartFormState = {
  description?: string,
  partNumber?: string,
  provider?: any,
  upc?: string,
  standardPrice?: string,
	msrp?: string,
	isBulk?: boolean,
	productClass?: ProductClass,
}
export type PartFormProps = {
  formState: PartFormState,
  setFormState: ( formState: PartFormState ) => void,
	canEditListPrice: boolean,
}

export default function PartForm( { formState, setFormState, canEditListPrice }: PartFormProps ): JSX.Element {
	const { provider, description, partNumber, upc, standardPrice, msrp } = formState

	const onChangeCurrency = ( field: string ) => ( value: string ) => setFormState( {
		...formState,
		[ field ]: value,
	} )

	const onChangeField = ( field: string ) => ( event: React.ChangeEvent<HTMLInputElement> ) => setFormState( {
		...formState,
		[ field ]: event.currentTarget.value,
	} )

	const onChangeProvider = ( _: any, providerOption?: any ) => setFormState( {
		...formState,
		provider: providerOption,
	} )

	const onChangeProductClass = ( _: any, productClass?: any ) => setFormState( {
		...formState,
		productClass,
	} )

	const onChangeIsBulk = () => setFormState( {
		...formState,
		isBulk: !formState.isBulk,
	} )

	return (
		<div className={styles.form}>
			<ProviderPicker
				label="Manufacturer"
				onChange={onChangeProvider}
				placeholder="Search for a Manufacturer..."
				selectedProvider={provider}
				required
			/>
			<EuiFormRow
				label="Manufacturer Number"
			>
				<EuiFieldText
					className="partNumber"
					onChange={onChangeField( 'partNumber' )}
					placeholder="e.g. WX-123456"
					required
					value={partNumber ?? ''}
				/>
			</EuiFormRow>
			<EuiFormRow
				label="Manufacturer Description"
			>
				<EuiFieldText
					onChange={onChangeField( 'description' )}
					placeholder="e.g. Oil Filter; Avoid asset make/models"
					value={description ?? ''}
				/>
			</EuiFormRow>

			<EuiCard
				title="Bulk Product"
				titleSize="xs"
				textAlign="left"
				hasBorder
			>
				<EuiFormRow label="Will this item be used for bulk rentals?">
					<EuiCheckbox
						id="forBulk"
						checked={formState.isBulk}
						onChange={onChangeIsBulk}
						label="Yes"
					/>
				</EuiFormRow>
				{ formState.isBulk && (
					<ProductClassPicker
						selectedProductClass={formState.productClass}
						onChange={onChangeProductClass}
					/>
				) }
			</EuiCard>

			<EuiFormRow
				label="UPC"
			>
				<EuiFieldText
					className={styles.upc}
					onChange={onChangeField( 'upc' )}
					value={upc ?? ''}
					maxLength={14}
				/>
			</EuiFormRow>

			<EuiFormRow
				label="List Price"
			>
				<CurrencyField
					onRawChange={( e ) => onChangeCurrency( 'standardPrice' )( e )}
					value={standardPrice ?? ''}
					disabled={!canEditListPrice}
				/>
			</EuiFormRow>

			<EuiFormRow
				label="MSRP"
			>
				<CurrencyField
					onRawChange={( e ) => onChangeCurrency( 'msrp' )( e )}
					value={msrp ?? ''}
				/>
			</EuiFormRow>
		</div>
	)
}
